import React from 'react'
import orderBy from 'lodash/orderBy'
import { useFeatureFlagContext } from 'utils/context/FeatureFlagsContext'
import { ShareLoadTableRow } from 'apps/fleet-planner/components/share-load/ShareLoadTableRow'
import * as Types from 'apps/fleet-planner/types'

interface IShareLoadTableProps {
  drivers?: Types.IDriver[]
  shares?: Types.IShare[]
}

export const ShareLoadTable: React.FC<IShareLoadTableProps> = ({ shares = [], drivers = [] }) => {
  // Only show shares that have been actually sent
  const filteredShares = orderBy(
    shares.filter(({ lastSharedAt }: Types.IShare): boolean => !!lastSharedAt),
    'lastSharedAt',
    'desc'
  )

  const { getFlag } = useFeatureFlagContext()
  const { enabled: isFmsOneTimeSmsLoadShareEnabled } = getFlag('fmsOneTimeSmsLoadShare')

  return (
    <div className='share-load-table'>
      <div className='share-load-table-header'>
        <div className='body-medium mb4'>
          {isFmsOneTimeSmsLoadShareEnabled ? 'Currently Sharing with' : 'Shared with'}
        </div>
      </div>
      <div className='share-load-table-body'>
        {!!filteredShares.length &&
          filteredShares.map(s => <ShareLoadTableRow share={s} key={s.id} drivers={drivers} />)}
        {!filteredShares.length && (
          <div className='share-load-table-empty-state'>
            <div className='body-medium text-secondary'>
              This load isn&apos;t shared with anyone.
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
